// Calculate REGULAR hours from an assignment, supporting direct hours or legacy start/end times
export function assignmentHours(a) {
  if (a.hours != null && a.hours > 0) return Number(a.hours);
  if (a.start_time && a.end_time) {
    try {
      const [sh, sm] = a.start_time.split(':').map(Number);
      const [eh, em] = a.end_time.split(':').map(Number);
      return Math.max(0, (eh * 60 + em - sh * 60 - sm) / 60);
    } catch {
      return 0;
    }
  }
  return 0;
}

export function assignmentOvertime(a) {
  const ot = a.overtime_hours;
  return ot != null && ot > 0 ? Number(ot) : 0;
}

// Sum regular + overtime hours grouped by a name field
export function totalsByName(items, nameKey) {
  const totals = {};
  let grandTotal = 0;
  let grandOvertime = 0;
  items.forEach((a) => {
    const name = a[nameKey] || 'Unknown';
    const h = assignmentHours(a);
    const ot = assignmentOvertime(a);
    if (!totals[name]) totals[name] = { hours: 0, overtime: 0 };
    totals[name].hours += h;
    totals[name].overtime += ot;
    grandTotal += h;
    grandOvertime += ot;
  });
  return {
    grandTotal: Math.round(grandTotal * 100) / 100,
    grandOvertime: Math.round(grandOvertime * 100) / 100,
    perName: Object.entries(totals)
      .map(([name, t]) => ({
        name,
        hours: Math.round(t.hours * 100) / 100,
        overtime: Math.round(t.overtime * 100) / 100,
      }))
      .sort((a, b) => b.hours + b.overtime - (a.hours + a.overtime) || a.name.localeCompare(b.name)),
  };
}
